import { useEffect, useMemo, useState } from 'react';
import { getLanguage, subscribeToLanguage, t as translateText } from './autoTranslate';

export function useI18nText() {
  const [language, setLanguageState] = useState(getLanguage());

  useEffect(() => subscribeToLanguage(setLanguageState), []);

  return useMemo(() => ({
    language,
    t: (key, fallback = key) => translateText(key, fallback, language),
    list: (items = []) => items.map((item) => translateText(item, item, language)),
  }), [language]);
}
